import { Redirect, Route as RouterRoute } from 'react-router-dom';
import { useAuth } from '@/app/providers/AuthProvider';
import { routes } from '@/app/routing/index';
import { getAuthorizedRedirectPath } from '@/app/routing/auth-redirect';
import Preloader from '@/common/components/Preloader';

const RouteLoader = () => <Preloader />;

const AuthenticatedRedirect = () => {
  const { user } = useAuth();
  return <Redirect to={getAuthorizedRedirectPath(user)} />;
};

export const ProtectedRoute = ({ roles, permissions, fallback, ...props }) => {
  const { isAuth, isAuthLoading, isAuthResolved, user } = useAuth();

  if (!isAuthResolved || isAuthLoading) {
    return <RouteLoader />;
  }

  if (!isAuth) {
    return <Redirect to={routes.login} />;
  }

  if (roles?.length && !roles.includes(user?.role)) {
    return <AuthenticatedRedirect />;
  }

  return <RouterRoute {...props} />;
};

export const PublicOnlyRoute = (props) => {
  const { isAuth, isAuthLoading, isAuthResolved } = useAuth();

  if (!isAuthResolved || isAuthLoading) {
    return <RouteLoader />;
  }

  return isAuth ? <AuthenticatedRedirect /> : <RouterRoute {...props} />;
};

export const FallbackRedirect = () => {
  const { isAuth, isAuthLoading, isAuthResolved } = useAuth();

  if (!isAuthResolved || isAuthLoading) {
    return <RouteLoader />;
  }

  return isAuth ? <AuthenticatedRedirect /> : <Redirect to={routes.login} />;
};

export const Route = ({ auth, guestOnly, ...props }) => {
  if (auth) {
    return <ProtectedRoute {...props} />;
  }

  if (guestOnly) {
    return <PublicOnlyRoute {...props} />;
  }

  return <RouterRoute {...props} />;
};

export default Route;
